/**
 * Bullet Physics runtime evaluation type
 */
export var PhysicsRuntimeEvaluationType;
(function (PhysicsRuntimeEvaluationType) {
    /**
     * Immediate physics evaluation for the current frame
     */
    PhysicsRuntimeEvaluationType[PhysicsRuntimeEvaluationType["Immediate"] = 0] = "Immediate";
    /**
     * Buffered physics evaluation for the next frame
     *
     * Asynchronous Multi-thread optimization applies when possible
     */
    PhysicsRuntimeEvaluationType[PhysicsRuntimeEvaluationType["Buffered"] = 1] = "Buffered";
})(PhysicsRuntimeEvaluationType || (PhysicsRuntimeEvaluationType = {}));
